import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=624396fc&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=624396fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624396fc",
  null
  
)

export default component.exports